import * as API from '@siloreal:shared:api';

const SILOBAG_SPECIES_LIST_ENDPOINT = '/silobagsSpeciesTypes';

export type SilobagSpeciesListServiceContract = {
  signal?: AbortSignal;
};

export async function listSilobagSpeciesService(
  contract: SilobagSpeciesListServiceContract = {}
): Promise<SilobagSpeciesListResponse> {
  const { data } = await API.http.fetch.get<SilobagSpeciesListResponse>(SILOBAG_SPECIES_LIST_ENDPOINT, {
    signal: contract.signal,
  });

  return data;
}

export type SilobagSpeciesListResponse = SilobagSpeciesListItem[];

export type SilobagSpeciesListItem = {
  id: number;
  name: string;
  reference: string | null;
  const_a: string | null;
  const_b: string | null;
  const_c: string | null;
  image_url: string;
  image_hash: string;
  lat: string | null;
  lon: string | null;
  timestamp: string | null;
  accuracy: string | null;
  created_at: Date | string;
  updated_at: Date | string | null;
};
